export enum EnumRetailerType {
  爭鮮 = 'SSE',
  CitySuper = 'CSM',
}

export enum EnumDownloadType {
  退貨驗收報表下載 = 'rptReturn',
  退貨通知報表下載 = 'rptReturnNote',
  退貨驗收批次預覽 = 'previewReturn',
  退貨通知批次預覽 = 'previewReturnNote',
  報表下載 = 'pdf',
  批次預覽 = 'preview',
  文字檔下載 = 'txt',
  貨號文字檔下載 = 'csv',
  TXT檔下載 = 'txt',
  CSV檔下載 = 'csv',
}

/** logRecord/query的 DocType使用 */
export enum EnumDocType {
  '訂單' = 'ORD',
  '驗收' = 'RCV',
  '退貨' = 'RTN,RTN_NOTE',
}

/** /queryWebRetailerSetup 的functionId參數，對應不同的功能 */
export enum EnumFunctionId {
  訂單 = 'ORDER_QUERY',
  驗收單 = 'RECEIVE_QUERY',
  退貨單 = 'RETURN_QUERY',
}

export enum EnumMasterSort {
  /** 是否為降冪排序 */
  desc = 'desc',
  /** 需排序的欄位屬性 */
  property = 'property',
}

export enum EnumFlatStyle {
  文字檔下載TXT = 'TXT',
  貨號文字檔CSV = 'CSV',
}

export enum EnumExportItemList {
  /** 報表下載 */
  rptDefault = 'rptDefault',
  /** 文字檔下載 */
  flatfileTxt = 'flatfileTxt',
  flatfileCsv = 'flatfileCsv',
  rptReturn = 'rptReturn',
  rptReturnNote = 'rptReturnNote',
  previewReturn = 'previewReturn',
  /** 批次預覽 */
  previewDefault = 'previewDefault',
  previewReturnNote = 'previewReturnNote',
  /** 貨號文字檔下載 */
  flatfileProdTxt = 'flatfileProdTxt',
}

export enum EnumRetailerSetup {
  queryConditions = 'queryConditions',
  queryResults = 'queryResults',
  exportItemList = 'exportItemList',
  queryDateList = 'queryDateList',
}
